import { render, staticRenderFns } from "./ISAForgotModal.vue?vue&type=template&id=23a4991a&scoped=true&"
import script from "./ISAForgotModal.vue?vue&type=script&lang=js&"
export * from "./ISAForgotModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a4991a",
  null
  
)

export default component.exports